exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".float-prop[data-v-06c806fa]{position:absolute;width:250px;height:200px;background:hsla(0,0%,100%,.35)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06c806fa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugins/components/Web3dModels/DefectPropertyWin.vue
// module id = 569
// module chunks = 0